(function () {
  stripeCardPayment.$inject = ["API_URL", "$rootScope", "$http", "$filter", "$location"];
  angular.module('directive.stripeCardPayment', []).directive('stripeCardPayment', stripeCardPayment);

  function stripeCardPayment(API_URL, $rootScope, $http, $filter, $location) {
    return {
      restrict: 'EA',
      replace: true,
      templateUrl: smooth.calendar_url + '/partials/directives/stripe-card-payment.html',
      scope: {
        paymentState: '=?',
        success: '=',
        appointments: '='
      },
      link: function link(scope, elem, attrs) {
        var stripe = window.Stripe(smooth.stripePublicKey),
            elements = stripe.elements();
        var stripeCard = elements.create('card', cardStyle);
        stripeCard.mount('#card-element');
        stripeCard.addEventListener('change', function (event) {
          var displayError = document.getElementById('card-errors');

          if (event.error) {
            displayError.textContent = event.error.message;
          } else {
            displayError.textContent = '';
          }
        });

        var tryPayment = function tryPayment(paymentMethodID) {
          var paymentIntentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var appointmentids = [],
              bookinginfo = {};
          scope.appointments.forEach(function (appointment) {
            appointmentids.push(appointment._id);
            if (appointment.bookinginfo) bookinginfo[appointment._id] = appointment.bookinginfo;
          });
          var params = {
            paymentstate: scope.paymentState,
            appointmentids: appointmentids
          };
          if (Object.keys(bookinginfo)) params.bookinginfo = bookinginfo;

          if (paymentMethodID) {
            params.payment_method_id = paymentMethodID;
          }

          if (paymentIntentId) {
            params.payment_intent_id = paymentIntentId;
          }

          return new Promise(function (resolve, reject) {
            // The payment method may require additional authentication (or not).
            // If it doesn't the transaction will complete. If it does, Stripe will
            // take the user through the additional steps and then the client will reply
            // to the server again with a payment intent for confirmation.
            $http.post(API_URL + '/stripe/submitpayment', params).then(function (reply) {
              $rootScope.throbber.hide();
              scope.processing = false;
              var response = reply.data;

              if (response.alreadydeleted) {
                $rootScope.throbber.showError("Unfortunately an error has occurred with this reservation. We're very sorry but you will need to restart the \n                                            reservation process. You have not been charged for this transaction.", function () {
                  localStorage.removeItem('reserved-appointments');
                  $location.path('/');
                });
                return;
              }

              if (response.success && !response.requiresaction) {
                return scope.success(response.appointments);
              }

              if (!response.success) {
                return $rootScope.throbber.showError(response.msg);
              }

              if (response.requiresaction) {
                $rootScope.throbber.show();
                scope.processing = true;
                stripe.handleCardAction(response.intentsecret).then(function (result) {
                  scope.processing = false;

                  if (result.error) {
                    return $rootScope.throbber.showError(result.error.message);
                  }

                  $rootScope.throbber.show();
                  tryPayment(null, result.paymentIntent.id);
                  resolve();
                });
                return;
              }

              console.error(response);
              alert('unhandled response');
            }).catch(function (error) {
              console.error(error.message);
              $rootScope.throbber.showError("Sorry but an error occurred with this request: ".concat(error.message));
              scope.processing = false;
            });
          });
        };

        scope.submitCard = function () {
          $rootScope.throbber.show();
          scope.processing = true; // Some payment methods and cards may require further authentication. In all cases
          // retrieve a payment intent from the server. If the transaction requires no further authentication
          // send back the payment intent ID to confirm the transaction.

          stripe.createPaymentMethod('card', stripeCard).then(function (result) {
            if (result.error) {
              scope.processing = false;
              return $rootScope.throbber.showError(result.error.message);
            }

            tryPayment(result.paymentMethod.id);
          });
        };

        scope.cancelPayment = function () {
          var cancelMessage = $filter('calendarLabel')('This will remove your reserved appointments. Continue?');

          if (!confirm(cancelMessage)) {
            return;
          }

          $location.path('/');
        }; // Style the Stripe elements component


        var cardStyle = {
          iconStyle: 'solid',
          style: {
            base: {
              iconColor: '#8898AA',
              color: '#000',
              lineHeight: '36px',
              fontWeight: 300,
              fontFamily: 'Hind, sans-serif',
              fontSize: '19px',
              '::placeholder': {
                color: '#8898AA'
              }
            },
            invalid: {
              iconColor: '#e85746',
              color: '#e85746'
            }
          },
          classes: {
            focus: 'is-focused',
            empty: 'is-empty'
          }
        };
      }
    };
  }
})();